import validator from 'validator'

export const isOnlyDigits = (value: string) => /^\d+$/.test(value)

export const isOnlyDigitsAndPoints = (value: string) => /\d\.*$/g.test(value)

export const isIpOrDnsAddress = (value: string) => {
    if (!value) {
        return false
    }

    if (validator.isIP(value) || value.toLowerCase() === 'localhost') {
        return true
    }

    if (validator.isFQDN(value)) {
        return true
    }

    return validator.isURL(value, {
        require_protocol: true,
        require_valid_protocol: true,
        protocols: ['http', 'https'],
    })
}
